module.exports = __webpack_public_path__ + "media/src/img/payment/sbp-1b3b9a17e0a6b15e05e37bca56c2fbf7.svg";